const getDisplayMessages = (messages) => {
  /**
   * Filter out empty messages first
   * @type {Array<Object>}
   * @description Removes messages with empty content
   */
  const filteredMessages = messages.filter(
    (message) => message.content && message.content.length > 0
  );

  /**
   * Groups messages in proper order: User → Assistant (with tool calls and thoughts)
   * @type {Array<Object>}
   * @description Orders messages correctly and groups tool calls and thoughts under assistant messages
   */
  const groupedMessages = (() => {
    const result = [];
    let currentThoughts = [];
    let currentToolCalls = [];
    let currentAssistant = null;

    for (let i = 0; i < filteredMessages.length; i++) {
      const message = filteredMessages[i];

      if (message.role === "user") {
        // If we have collected thoughts and tool calls but no final response,
        // create an incomplete assistant message
        if (currentThoughts.length > 0 || currentToolCalls.length > 0) {
          result.push({
            role: "assistant",
            content: "",
            complete: false,
            thoughts: currentThoughts.length > 0 ? currentThoughts : undefined,
            tool_calls:
              currentToolCalls.length > 0 ? currentToolCalls : undefined,
          });
        }

        // Reset for new conversation
        currentThoughts = [];
        currentToolCalls = [];
        currentAssistant = null;

        // Add user message
        result.push({ ...message, index: i });
      } else if (message.role === "assistant") {
        if (
          !message.content.startsWith("<final-response>") &&
          !message.content.endsWith("</final-response>")
        ) {
          // This is a thinking message, add to thoughts
          currentThoughts.push({ ...message, index: i });
        } else {
          // This is the final response, create complete assistant message
          currentAssistant = { ...message };

          // Look ahead to collect all remaining tool calls and thoughts
          let j = i + 1;
          while (
            j < filteredMessages.length &&
            filteredMessages[j].role !== "user"
          ) {
            const nextMessage = filteredMessages[j];
            if (nextMessage.role === "tool") {
              currentToolCalls.push({
                ...nextMessage,
                count: currentToolCalls.length + 1,
                index: j,
              });
            } else if (
              nextMessage.role === "assistant" &&
              nextMessage.content.startsWith("Thinking")
            ) {
              currentThoughts.push({ ...nextMessage, index: j });
            }
            j++;
          }

          // Add the complete assistant message
          result.push({
            ...currentAssistant,
            thoughts: currentThoughts.length > 0 ? currentThoughts : undefined,
            tool_calls:
              currentToolCalls.length > 0 ? currentToolCalls : undefined,
          });

          // Reset for next conversation
          currentThoughts = [];
          currentToolCalls = [];
          currentAssistant = null;
        }
      } else if (message.role === "tool") {
        // Add tool message to current collection
        currentToolCalls.push({
          ...message,
          count: currentToolCalls.length + 1,
          index: i,
        });
      }
    }

    // Handle any remaining incomplete conversation
    if (currentThoughts.length > 0 || currentToolCalls.length > 0) {
      result.push({
        role: "assistant",
        content: "",
        complete: false,
        thoughts: currentThoughts.length > 0 ? currentThoughts : undefined,
        tool_calls: currentToolCalls.length > 0 ? currentToolCalls : undefined,
      });
    }

    return result;
  })();

  return groupedMessages;
};

export default getDisplayMessages;
